/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userBusinessGiftCards.internal

import features.userBusinessGiftCards.models.UserBusinessGiftCardsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserBusinessGiftCardsServiceImpl : UserBusinessGiftCardsService {

    private val userBusinessGiftCardsRequest = UserBusinessGiftCardsRequest()

    override suspend fun getUserBusinessGiftCards(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<UserBusinessGiftCardsModel> {
        return userBusinessGiftCardsRequest.getUserBusinessGiftCards(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
